import { Dialog } from "@rio-cloud/rio-uikit";
import { Select } from "@rio-cloud/rio-uikit";
import { useState } from "react";
import { useIntl } from "react-intl";
import { OccurrenceDispatch } from "../../../../../../../models/occurrence";
import { Occurrence } from "../../../../../../../models/occurrence";
import SuccessDialog from "../../../../../../dialogs/SuccessDialog";
import ErrorDialog from "../../../../../../dialogs/ErrorDialog";
import { reasonsRefusalLabelIds, reasonsRefusalOptions, translateDispatchOptions } from "../../../../../../../hooks/useDispatch";

interface CancelDispatchDialogProps {
  open: boolean;
  onClose: () => void;
  occurrence?: Occurrence | null;
  occurrenceDispatch: OccurrenceDispatch;
  cancelDispatch?: (occurrence: Occurrence, dispatch: OccurrenceDispatch, reason: string, description: string) => Promise<{ wasCanceled: boolean, error?: string, dispatch?: OccurrenceDispatch }>;
  updateStatus: (status: string, reason: string, description: string) => void;
}

const CancelDispatchDialog = (props: CancelDispatchDialogProps) => {
  const intl = useIntl();
  const [loading, setLoading] = useState(false);

  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [errorDialogBody, setErrorDialogBody] = useState<string>("");
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);

  const [form, setForm] = useState<{
    reason: string;
    description: string;
  }>({
    reason: "",
    description: "",
  });

  const isFormValid = form.reason !== "" && form.description.trim() !== "";

  return (
    <>
      <Dialog
        show={props.open}
        onClose={props.onClose}
        showCloseButton
        bsSize={Dialog.SIZE_MD}
      >
        <>
          <Dialog.Title title={intl.formatMessage({ id: "intl-msg:kanban.form.cancelDispatchDialog.title" })} />
          <Dialog.Body>
            <div className="cancel-content flex flex-col">
              <div className="form-group form-group-lg w-full">
                <label className="truncate">{intl.formatMessage({ id: "intl-msg:kanban.form.cancelDispatchDialog.reasonLabel" })}</label>
                <Select
                  id="1"
                  placeholder={intl.formatMessage({ id: "intl-msg:kanban.form.cancelDispatchDialog.reasonPlaceholder" })}
                  options={translateDispatchOptions(intl, reasonsRefusalOptions, reasonsRefusalLabelIds)}
                  onChange={(option: any) =>
                    setForm({ ...form, reason: option?.id ?? "" })
                  }
                />
              </div>

              <div className="form-group form-group-lg w-full">
                <label className="!font-bold" htmlFor="textParecer">
                  {intl.formatMessage({ id: "intl-msg:kanban.form.cancelDispatchDialog.opinion" })}
                </label>
                <textarea
                  className="form-control !h-[100px]"
                  id="textParecer"
                  value={form.description}
                  onChange={(e) => setForm({ ...form, description: e.target.value })}
                ></textarea>
              </div>

              <hr />

              <div className="flex flex-col gap-6 py-[10px]">
                <span className="text-size-14 text-color-dark">
                  {intl.formatMessage({ id: "intl-msg:kanban.form.cancelDispatchDialog.aboutToRefuse" })}
                </span>
                <span className="text-size-14 text-color-dark">
                  {intl.formatMessage({ id: "intl-msg:kanban.form.cancelDispatchDialog.continueAnyway" })}
                </span>
              </div>
            </div>
          </Dialog.Body>
          <Dialog.Footer>
            <div className="flex items-center justify-end py-[10px]">
              <div className="flex items-center gap-6">
                <p
                  className="text-bold text-size-16 cursor-pointer text-color-primary"
                  onClick={props.onClose}
                >
                  {intl.formatMessage({ id: "intl-msg:kanban.form.cancelDispatchDialog.back" })}
                </p>
                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={!isFormValid || loading}
                  onClick={async () => {
                    if (!props.occurrence || !props.cancelDispatch) {
                      setShowErrorDialog(true);
                      setErrorDialogBody(intl.formatMessage({ id: "intl-msg:dispatch.error.occurrence-not-found" }));
                      return;
                    }

                    setLoading(true);
                    const { wasCanceled, error, dispatch } = await props.cancelDispatch(props.occurrence, props.occurrenceDispatch, form.reason, form.description);
                    if (wasCanceled) {
                      props.onClose();
                      props.updateStatus("Indisponível para atendimento", form.reason, form.description);
                    } else {
                      setShowErrorDialog(true);
                      setErrorDialogBody(error ?? intl.formatMessage({ id: "intl-msg:kanban.form.cancelDispatchDialog.cancelError" }));
                    }
                    setLoading(false);
                  }}
                >
                  {intl.formatMessage({ id: "intl-msg:kanban.form.cancelDispatchDialog.continue" })}
                </button>
              </div>
            </div>
          </Dialog.Footer>
        </>
      </Dialog>

      <ErrorDialog
        show={showErrorDialog}
        onClose={() => setShowErrorDialog(false)}
        title={intl.formatMessage({ id: "intl-msg:kanban.form.cancelDispatchDialog.cancelError" })}
        body={errorDialogBody}
      />

      <SuccessDialog  
        show={showSuccessDialog}
        onClose={() => setShowSuccessDialog(false)}
        title={intl.formatMessage({ id: "intl-msg:kanban.form.cancelDispatchDialog.successTitle" })}
        body={intl.formatMessage({ id: "intl-msg:kanban.form.cancelDispatchDialog.successBody" })}
      />
    </>
  );
};

export default CancelDispatchDialog;
